let redirecting = false

const appBase = (process.env.BASE_URL || '/').replace(/\/+$/, '')
const loginPath = `${appBase}/login`

export function redirectToLogin() {
  EUtils.delCookie('Authorization')
  if (redirecting || window.location.pathname === loginPath) return
  redirecting = true
  const currentPath = window.location.pathname.startsWith(`${appBase}/`)
    ? window.location.pathname.slice(appBase.length)
    : window.location.pathname
  const returnTo = `${currentPath}${window.location.search}${window.location.hash}`
  const destination = returnTo === '/login'
    ? loginPath
    : `${loginPath}?redirect=${encodeURIComponent(returnTo)}`
  window.location.replace(destination)
}

export function isUnauthorized(status, body) {
  return Number(status) === 401 || Number(body && body.code) === 401 ||
    Number(body && body.status) === 401 || Number(body && body.error && body.error.code) === 401
}
